const kr = {
  common: {
    smartPhoneOrder: 'スマホで注文',
    seatNumber: '좌석번호',
    orderIsNowAvailableWithASmartphone: '스마트폰으로 주문을 할 수 있습니다',
    readTheQrCodeAgainAfterClosingTheApp:
      '어플리케이션을 종료할 경우에는 다시한번 QR코드를 읽어주십시오',
    orderWithOtherSmartphones: '다른 스마트폰으로 주문',
    youCouldOrderWithOtherSmartphonesByReadingTheQrCodeShownOnThisPhone:
      '해당 스마트폰에 표시하는 QR코드를 읽으면, 다른 스마트폰으로 주문이 가능합니다',
    showTheQrCode: 'QR 코드를 표시합니다',
    youCouldOrderWithAMaximumOf6Smartphones: '최대 6개의 스마트폰에서 주문할 수 있습니다',
    close: '닫기',
    howToUse: '사용법',
    doNotDisplayThisDialogAgain: '이후 표시하지않기',
    todaysSpecialMenu: '오늘의 추천',
    cancel: '취소',
    numberBefore: '',
    numberAfter: '번',
    finishedDishes: '투입 접시 수',
    dishes: '접시',
    call: '호출',
    check: '회계',
    home: '홈 화면',
    search: '검색',
    return: '돌아 가기',
    pleaseWaitTheEmployeeWillArriveShortly: '종업원이 방문하겠습니다.\n잠시만 기다려주십시오.',
    cancelTheCall: '호출취소',
    orderWithOtherCustomersSmartphone: '동반하신 손님도 스마트폰으로 주문하기',
    order: '주문하기',
    yes: 'はい',
    no: 'いいえ',
    end: '終了する',
    putIn: '投入完了',
    staffCalling: '店員呼び出し',
    smartphoneOrderSuccess: 'スマホで注文を終了',
    certification: '認証中',
    pleaseWait: 'しばらくお待ちください',
    busyTimes: '混み合っていると画面が切り替わるまでに\nお時間がかかる場合があります',
    scanTheQRCodeAgain: '画面が切り替わらない場合は\nお手数ですがQRコードを読み取り直してください',
    recommendMenu: '추천',
    callStaff: '呼び出し',
    cancelCall: '呼び出しキャンセル',
    yen: '円',
    twGen: '元(台湾元)',
    cnGen: '元(中華人民元)',
    dollar: '{price}ドル',
    calorieUnit: 'kcal',
  },
  welcome: {
    smartPhoneOrderDescription:
      'タッチパネルのQRコードを読み取ると、\nスマホから注文ができるサービスです。',
    availableShopList: 'ご利用可能店舗一覧はこちら',
    operationMethod: '操作方法',
    alreadyInstalledApp: 'くら寿司アプリをお持ちの方',
    alreadyInstalledAppDescription:
      'アプリ内の「スマホで注文」ボタンからカメラを起動し、タッチパネルのQRコードを読み取ってください。',
    notInstalledApp: 'くら寿司アプリをお持ちではない方',
    notInstalledAppDescription:
      'カメラアプリを起動し、タッチパネルのQRコードを読み取ってください。',
  },
  preOrder: {
    'pre-orderConfirm': '사전주문확정',
    pleaseReadTheQrCodeAfterTheGuidance: '안내 후 QR 코드를 스캔하십시오',
    'thePre-orderingMenuIs10ForMaximum': '사전 주문 수량은 10 종까지입니다.',
    appointmentNumber: '予約番号',
    comfirming: '確認中',
    shop: '店',
    receptionNumber: '受付番号',
    reservationUsherTime: '案内予定時刻',
    numberOfReservations: '予約人数',
    preOrder: '事前注文',
    preOrderhowToUseDescription:
      '赤色のボタンを押し\nQRコードを読み込むことで\n注文が送信されます。',
    soldOutDescription: '着席前に品切れになった\n注文は送信されません。',
    preOrderLimitOver: '事前注文枠を超えています。着席後に再度注文が可能です。',
  },
  sideMenu: {
    settings: '설정',
    menuAppearance: '메뉴 표시',
    menuLarge: '큰',
    menuSmall: '작은',
    languageSettings: '언어 설정',
    showTheQrCodeAuthenticationForConnectingWithOtherSmartphones: '기기인증 QR을 표시하기',
    closeTheOrderScreenWithTheSmartphone: '스마트 폰에서 주문하기 화면 닫기',
    regardingSmartPhoneOrder: 'スマホで注文について',
    showAllergenInformation: 'アレルゲン情報を表示する',
  },
  orderHistory: {
    orderHistoryOfThisWholeTableWillBeDisplayed: '테이블 전체 주문 내역이 표시되어 있습니다.',
    orderHistory: '주문내역',
    todaysOrderHistory: '오늘의 주문내역',
    arrived: '제공하였습니다',
    'nMenusOfOrderAtYourLastArrivalAtOurStoreWillBeShown-prefix':
      '이전 방문하셨을떄 주문한, 과거 주문 내역 ',
    'nMenusOfOrderAtYourLastArrivalAtOurStoreWillBeShown-suffix': ' 건이 표시되어 있습니다',
    orderFromSmartphone: 'スマホからのご注文',
    arriveComplete: '送達済',
    orderPending: '注文保留',
    pastOrderHistory: '過去の注文履歴',
    pastOrderHistoryDescription:
      '※31日以内の注文履歴が100件以上ある場合は、最新の注文履歴100件が表示されます。',
  },
  search: {
    searchCandidates: '候補',
    searchDescription: '入力すると候補が表示されます\n候補をタップして確定してください',
    searchResultBefore: '',
    searchResultAfter: 'の検索結果',
    listening: '音声入力受付中',
  },
  howToUse: {
    howToOrderWithTheSmartphone: '스마트 폰에서 주문하기 사용 방법',
    canOrderWithSmartPhone: 'スマートフォンから注文できます。',
    sideMenuAlsoCanMakeBikkuraPon: 'サイドメニューでも\nビッくらポンができます。',
    canCompleteOrderBeforeMeal: 'お席に座る前に\n注文を決められます。',
    preOrderAfterReserved:
      '予約完了後に予約注文出来るようになります。\n客席のQRコードを読み取った段階で注文が反映されます。',
    noLimitForOrder: '1席で、人数制限なく\nスマホで注文できます。',
    scanQrAndStart: 'タッチパネルのQRコードを読み取ると\nスマホから注文出来るようになります。',
  },
  order: {
    thankYouForYourOrder: '주문 감사합니다',
    theOrderHasBeenReceived: '주문이 접수되었습니다. ',
    arrangeOfSpecialAndPopularMenu: '인기 · 추천 조합',
    cancelTheCheck: '회계 취소',
    orderCancelConfirmation: '注文をキャンセルしますか？',
    pleaseWait: 'しばらくお待ちください。',
    checkCancelDescription: 'お会計のキャンセルは、\n備え付けのタッチパネルからお願いします。',
    endOrder: 'スマホで注文を終了します',
    askEndOrder: 'スマホで注文を終了します。よろしいですか？',
    endOrderConfirmation: 'スマホで注文を終了しますか？',
    endOrderAttention:
      '他に「スマホで注文」を利用している端末がない場合、本日の注文履歴や、スマホでビッくらポンのポイントは失われます。よろしいですか？',
    endSession: 'セッションが終了されたためスマホで注文を終了します。',
  },
  bikkuraPon: {
    'bikkura-pon': '빅쿠라폰',
    'bikkura-pon-jp': '빅쿠라폰',
    smartPhoneOrderLimited: 'スマホで注文限定',
    bikkuraPonExplanationBefore: 'このマークがある商品をスマホからご注文頂くと、',
    bikkuraPonExplanationAfter: '毎にビッくらポンを一回遊べます。',
    startBikkuraPon: 'ビッくらポン！で遊ぶ',
    howToStartBikkuraPon: 'タップすると\nビッくらポンが遊べます。',
    pressToStartBikkuraPon: 'タップしてはじめる。\nビッくらポン！で遊ぶ',
    bikkuraPonConfirmation: 'ビッくらポンをプレイしますか？',
    remainingTimes: 'あと {count} 回プレイできます。',
    start: 'プレイ',
    bikkuraPonUnabled: 'ビッくらポンをプレイできませんでした',
    drawingFailure:
      'ビッくらポンの抽選に失敗しました。\n通信環境や残りのプレイ回数をお確かめの上、再度お試しください。',
    bikkuraPonInProgress: 'ビッくらポン抽選中',
    bikkuraPonInProgressDescription:
      '現在、ビッくらポン抽選中です。\nしばらくたってから再度お試しください。',
    congratulations: 'あたり',
    lose: 'はずれ',
  },
  present: {
    arrivedPresent: 'くら寿司からプレゼントが届いております。',
    cannotCancelOperation: '※操作は取り消せません',
    notReceive: '受け取らない',
    receive: '受け取る',
  },
  textInImage: {
    waitingArea: '待合室',
    jackpot: 'あたり',
    lose: 'ハズレ',
    numberPlate: '案内票',
  },
  error: {
    oparateFromTouchPanel: '제공된 터치 패널에서 작동하십시오.',
    networkError: '네트워크 요청이 실패했습니다.',
    failedToProcess: '処理に失敗しました',
    notFound: 'お探しのページは見つかりません',
    notFoundOrRemoved: 'お探しのページは存在しないか、\n移動もしくは削除された可能性があります。',
    operatingAgainOnTopPage:
      'お手数ですが、「くら寿司 スマホで注文」の\nトップページより、再度お試しください。',
    backToTop: 'トップページへ戻る',
    limitErrorDescription:
      'ただいま大変混み合っているため注文を制限させていただいております。大変申し訳ありませんが少々お待ちください。',
    orderStopErrorDescription:
      'ただいま大変混み合っているため受付を停止させていただいております。大変申し訳ありませんが少々お待ちください。',
    stockoutErrorDescription: '商品の在庫がありませんでした。別の商品をお試しください。',
    unableToAuthenticate: '認証ができませんでした',
    failureToAuthorization: '認証に失敗しました。',
  },
  selfcheck: {
    comfirmNumbers: '人数確認',
    singleSeatCheckOut: 'おひとりさまで\n会計されますか？',
    multiSeatsCheckOut:
      '複数の座席をまとめて会計する場合は、\nいいえを選択してください。\n店員がお席までお会計へ伺います。',
    dishesConfirm: 'お皿の確認',
    paymentConfirm: '金額の確認',
    sushiPlate: '寿司皿',
    redPlate: 'えくぼ皿',
    buckleSeparate: '2皿リングは分解',
    putThePlateInThrowingSlot: 'お皿を投入口に\nお入れください。',
    accountingConfirmation: 'お会計 ご確認',
    contents: '内容',
    quantity: '数量',
    totalAmount: '合計金額(税込)',
    checkConfirmed: 'お会計が確定しました。',
    takeNumberPlateToTheCounter: '案内票を持って\nレジにお進みください。',
    checking: '会計中',
    waitUntilRedirect: 'お会計が確定したら\n自動で画面が切り替わります。',
    howToCancelSelfcheck:
      'お会計のキャンセルは、\nお会計中の端末から\nキャンセルボタンをタップするか、\n備え付けのタッチパネルからお願いします。',
    checkOutContentHasBeenChanged: 'お会計内容が変わりました',
    pleaseCheckAgain: 'もう一度ご確認ください。',
    closeCheckPageConfirmation: 'お会計を終了しますか？',
    abortCheckAndBackToMainConfirmation:
      'お会計を終了し、メニュー画面へ戻ります。\nよろしいですか？',
    howToCancelCheckOut: 'お会計のキャンセルは、 備え付けのタッチパネルからお願いします。',
    smartphoneOrderFinished: 'スマホで注文を終了',
    staffComingPleaseWait: '店員を呼び出しております。\n少々お待ちください。',
    error: 'エラー',
    failedToLoading: '読み込みに失敗しました',
    selfcheckTryAgainApology:
      '読み込みに失敗したため、\nお会計を中断します。\nメニュー画面へ戻り、\nもう一度最初からやり直してください。',
    backToMainMenu: 'メニュー画面へ戻る',
    selfcheckRestartApology:
      '処理に失敗したため、メニュー画面へ戻ります。\n画面が切り替わらない場合は、お手数ですが備え付けのタッチパネルから戻るボタンをタップし、タッチパネルから操作を行ってください。',
    selfcheckWaitMomentApology:
      'お会計に失敗しました。\nしばらく経ってから再度お試しください。\n解消されない場合は、お手数ですが店員を呼び出すか、備え付けのタッチパネルから操作を行ってください。',
    calling: '呼出',
    confirming: '確認中です',
    useTouchPanel:
      'お手数ですが備え付けのタッチパネルから戻るボタンをタップし、タッチパネルから操作を行ってください。',
  },
  pageTitle: {
    shopMenu: '홈 화면',
    order: '주문하기',
    ad: '오늘의 추천',
    adOrder: '오늘의 추천',
    recommendOrder: '추천',
    history: '주문내역',
    historyOrder: '주문내역',
    search: '검색',
    searchOrder: '검색',
  },
  siteId: 'SmartPhone Order | KURA SUSHI',
}

export default kr
